import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  updateExitRowData: {},
  isLoading: false,
  hasData: false,
  error: "",
  updateExitRowStatus: {
    status: false,
    message: ""
  }
};
const updateExitRowSlice = createSlice({
  name: "updateExitRow",
  initialState,
  reducers: {
    updateExitRowRequest: (state, action) => {
      state.isLoading = true;
    },
    updateExitRowSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.updateExitRowData = action.payload;
      state.updateExitRowStatus.status = true;
      state.updateExitRowStatus.message = action?.payload?.message;
    },
    updateExitRowFailure: (state, action) => {
      state.isLoading = false;
      state.error = action?.payload?.response?.data;
      state.updateExitRowData = {};
      state.updateExitRowStatus.status = false;
      state.updateExitRowStatus.message = "";
    },
    resetUpdateExitRowData: state => {
      state.updateExitRowData = {};
      state.isLoading = false;
      state.hasData = false;
      state.error = "";
      state.updateExitRowStatus.status = false;
      state.updateExitRowStatus.message = "";
    }
  }
});
export const {
  updateExitRowRequest,
  updateExitRowSuccess,
  updateExitRowFailure,
  resetUpdateExitRowData
} = updateExitRowSlice.actions;
export default updateExitRowSlice.reducer;